let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0aSm")).then(() => parcelRequire('7tb5a'));